import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group-title" }


const __default__ = { name: "MasFormGroupTitle" };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  title: {
    type: String,
    default: "111",
  },
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(_toDisplayString(__props.title) + " ", 1),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})